import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'gtapp-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BarChartComponent implements OnInit, OnChanges {
  @Input() barChartData: any = [];
  @Input() otherParams: any;
  @Input() charInfo: any;

  @Output() paginationChange = new EventEmitter();
  @Output() barClick = new EventEmitter();
  paginatedChartData: any;
  maxChartValue: number = 0;

  defaultChartHeight: number = (screen.height * 45) / 100; // x % of screen height
  averageValue: number = 0;
  averageValueInPx: any;

  //pagination params
  totalRows: number = 0;
  previousRows: number = 0;
  rows: number = 30;
  pageNum: number = 1;
  totalPages: number = 0;

  apiFiltering: boolean = false;
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    this.apiFiltering = Boolean(this.otherParams?.apiFiltering);
    if (this.otherParams?.paginationData?.rows >= 0) {
      this.totalRows = this.otherParams?.paginationData?.totalRows;
      this.previousRows = this.otherParams?.paginationData?.previousRows;
      this.rows = this.otherParams?.paginationData?.rows;
      this.pageNum = this.otherParams?.paginationData?.pageNum;
      this.totalPages = this.otherParams?.paginationData?.totalPages;
    }
    this.paginatedChartData = JSON.parse(JSON.stringify(this.barChartData));

    if (this.otherParams?.paginationData && !this.apiFiltering) {
      this.totalRows = this.barChartData?.length;
      this.totalPages = Math.ceil(this.totalRows / this.rows);
      this.paginatedChartData = this.barChartData?.slice(0, this.rows);
    }
    this.updateGraph();
  }
  updateGraph() {
    const barChartValue: any = this.charInfo?.value?.name;

    const allAvailableValues = this.paginatedChartData?.map(
      (item: any) => item?.[barChartValue],
    );
    this.maxChartValue =
      Math.max(...allAvailableValues) || this.defaultChartHeight;
    try {
      const sumValue =
        allAvailableValues?.reduce((sum: any, val: any) => sum + val) || 1;

      this.averageValue = Math.round(
        sumValue / this.paginatedChartData?.length,
      );

      this.averageValueInPx = `${
        Math.round(
          this.defaultChartHeight * (this.averageValue / this.maxChartValue),
        ) +
        (20 + 26 + 25)
      }px`; // adding the padding  of bar chart class and the height of bar label and height og avg value
    } catch (error) {}
  }
  onChangePagination(event: any) {
    this.previousRows = event.previous;
    this.pageNum = event.pageNum;
    this.rows = event.pageSize;
    if (this.apiFiltering) {
      this.paginationChange.emit({
        paginationData: {
          totalRows: this.totalRows,
          previousRows: this.previousRows,
          rows: this.rows,
          pageNum: this.pageNum,
          totalPages: this.totalPages,
        },
      });
    } else {
      this.paginatedChartData = this.barChartData?.slice(
        this.previousRows,
        this.rows * this.pageNum,
      );
      this.updateGraph();
    }
  }
}
